module.exports = __webpack_public_path__ + "static/media/hollow_bar_packShip_tall.4b53e3e3.svg";